import { DataState } from '@shared/enums/DataState';
import { AsyncData } from '@shared/interfaces/asyncData';
import { SurveyQueue } from '../interfaces';

export enum RunSurveyErrorType {
  Conflict = 'Conflict',
  Generic = 'Generic',
}

export interface State {
  surveyQueue: AsyncData<SurveyQueue>;
  runSurveyStatus: DataState;
  runSurveyErrorType: RunSurveyErrorType | null;
}

export interface SetSurveyQuestionOrderPayload {
  order: number;
  questionId: string;
}

export interface SetSurveyCategoryOrderPayload {
  order: number;
  categoryId: string;
  isActive: boolean;
  prevIsActive: boolean;
}

export interface SetCategoryNamePayload {
  name: string;
  categoryId: string;
}

export interface SetQuestionTextPayload {
  text: string;
  questionId: string;
}

export interface CreateCategoryPayload {
  questionId: string;
  categoryId: string;
  questionText: string;
  categoryName: string;
}

export interface CreateQuestionPayload {
  questionId: string;
  categoryId: string;
  text: string;
}
